import styled from "@emotion/styled";

export const MapContainer = styled.div`
width: 100%;
flex-grow: 1;
height: 100%;
`